export default {
  name: null,
  sector: null,
}
